module.exports = __webpack_public_path__ + "img/top5.8bb78051.png";